import script from "./TitleBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleBar.vue?vue&type=script&lang=ts&setup=true"

import "./TitleBar.vue?vue&type=style&index=0&id=92c08098&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92c08098"]])

export default __exports__